import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'IN_PROGRESS',
        items: [],
        aggregations: {}
    }));

    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'ERROR',
        errors: action.errors,
        aggregations: {}
    }));

    return state.set('collections', collections);
}

export function finish(state, { id, data, aggregations }) {
    let collections = state.get('collections');

    collections = collections.set(id, fromJS({
        state: 'FINISHED',
        items: fromJS(data.map(bet => bet.id)),
        aggregations
    }));

    let items = state.get('items');
    for (let bet of data) {
        items = items.set(bet.id, fromJS(bet));
    }

    return state
        .set('items', items)
        .set('collections', collections);
}

export function clear(state, { id }) {
    return state.set(
        'collections',
        state.get('collections').remove(id)
    );
}

